const ALLOWED_TAGS = new Set([
  'p', 'br', 'span', 'pre', 'strong', 'b', 'em', 'i', 'u', 's', 'strike',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ol', 'ul', 'li', 'blockquote',
  'a', 'img', 'table', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td'
])

const DROP_CONTENT_TAGS = new Set(['script', 'style', 'iframe', 'object', 'embed', 'link', 'meta', 'svg'])
const ALLOWED_STYLE_PROPERTIES = new Set([
  'color', 'background-color', 'border', 'border-color', 'border-style',
  'border-width', 'width', 'height', 'text-align', 'vertical-align',
  'padding', 'padding-left', 'padding-right', 'padding-top', 'padding-bottom',
  'font-size', 'text-indent'
])

function isAllowedUrl (value, allowDataImage) {
  const url = (value || '').trim()
  if (/^(https?|mailto|tel):/i.test(url)) return true
  if (/^(\/(?!\/)|#)/.test(url)) return true
  if (allowDataImage && /^data:image\/(gif|jpe?g|png|webp);base64,/i.test(url)) return true
  return false
}

function sanitizeStyle (value) {
  return value.split(';').map(function (declaration) {
    const parts = declaration.split(':')
    if (parts.length < 2) return ''
    const property = parts.shift().trim().toLowerCase()
    const propertyValue = parts.join(':').trim()
    if (!ALLOWED_STYLE_PROPERTIES.has(property)) return ''
    if (!propertyValue || /url\s*\(|expression\s*\(|javascript:|@import/i.test(propertyValue)) return ''
    return property + ': ' + propertyValue
  }).filter(Boolean).join('; ')
}

function sanitizeAttributes (element) {
  const tag = element.tagName.toLowerCase()
  Array.from(element.attributes).forEach(function (attribute) {
    const name = attribute.name.toLowerCase()
    const value = attribute.value
    const isQuillClass = name === 'class' && value.split(/\s+/).every(token => !token || /^ql-/.test(token))
    const isTableId = ['table_id', 'row_id', 'cell_id'].indexOf(name) >= 0
    const isTableAttribute = ['colspan', 'rowspan', 'width', 'height', 'align', 'valign'].indexOf(name) >= 0
    const isAllowed = isQuillClass || isTableId || isTableAttribute ||
      (tag === 'a' && ['href', 'target', 'rel'].indexOf(name) >= 0) ||
      (tag === 'img' && ['src', 'alt', 'width', 'height'].indexOf(name) >= 0) ||
      (name === 'style')

    if (!isAllowed || /^on/i.test(name)) {
      element.removeAttribute(attribute.name)
      return
    }

    if (name === 'href' && !isAllowedUrl(value, false)) element.removeAttribute(attribute.name)
    if (name === 'src' && !isAllowedUrl(value, true)) element.removeAttribute(attribute.name)
    if (name === 'target' && value !== '_blank') element.removeAttribute(attribute.name)
    if (name === 'rel') element.setAttribute('rel', 'noopener noreferrer')
    if (name === 'style') {
      const style = sanitizeStyle(value)
      if (style) element.setAttribute('style', style)
      else element.removeAttribute('style')
    }
  })
}

function sanitizeNode (node) {
  Array.from(node.childNodes).forEach(function (child) {
    if (child.nodeType === 8) {
      node.removeChild(child)
      return
    }
    if (child.nodeType !== 1) return

    const tag = child.tagName.toLowerCase()
    if (DROP_CONTENT_TAGS.has(tag)) {
      node.removeChild(child)
      return
    }
    if (!ALLOWED_TAGS.has(tag)) {
      while (child.firstChild) node.insertBefore(child.firstChild, child)
      node.removeChild(child)
      return
    }

    sanitizeAttributes(child)
    sanitizeNode(child)
  })
}

export default function sanitizeHTML (html) {
  if (html == null || html === '') return html
  if (typeof DOMParser === 'undefined') return ''
  const document = new DOMParser().parseFromString(String(html), 'text/html')
  sanitizeNode(document.body)
  return document.body.innerHTML
}
